import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AccordionModule } from "primeng/accordion";
import { CardModule } from "primeng/card";
import { TableModule } from "primeng/table";
import { TabsModule } from "primeng/tabs";
import { TagModule } from "primeng/tag";
import { CustomerInvoice } from "src/app/models/customer-invoice.model";
import { InvoiceType } from "src/app/models/enums/invoice-type.enum";
import { GroupByPipe } from "src/app/pipes/groupBy.pipe";
import { OrderByPipe } from "src/app/pipes/orderBy.pipe";
import { UniquePipe } from "src/app/pipes/unique.pipe";
import { InvoiceService } from "src/app/services/invoice.service";
import { InvoiceDetailComponent } from "../invoice-detail/invoice-detail.component";

@Component({
    selector: 'invoices-component',
    standalone: true,
    templateUrl: './invoices.component.html',
    styleUrls: ['./invoices.component.scss'],
    imports: [AccordionModule, CardModule, CommonModule, OrderByPipe, FormsModule, UniquePipe, TableModule, TabsModule, TagModule, InvoiceDetailComponent],
    providers: [InvoiceService, GroupByPipe],
})
export class InvoicesComponent {
    invoicesGroupedByMonth: Record<string, CustomerInvoice[]> = {};
    invoices: CustomerInvoice[] = [];
    invoiceDetailVisible: boolean[] = [];
    totalCount: number = 0;
    itemsPerPage: number = 5;
    view: string = 'list';
    Object = Object;
    InvoiceType = InvoiceType;

    constructor(private invoiceService: InvoiceService, private groupByPipe: GroupByPipe) { 
        this.invoiceService.getInvoices(0, this.itemsPerPage).subscribe(result => {
            this.invoices = result.customerInvoices;
            this.totalCount = result.totalCount;
            this.groupByPipe.transform(result.customerInvoices, 'invoiceDate', '| date : MMMM yyyy, UTC, en-US').then(
                (result) => {
                    this.invoicesGroupedByMonth = result;
                    console.log(this.invoicesGroupedByMonth);
                    console.log(this.Object.keys(this.invoicesGroupedByMonth));
                }
            );
        });
    }

    pageChange(event: any) {
        this.invoiceService.getInvoices(event.first / event.rows, event.rows).subscribe(result => {
            this.invoices = result.customerInvoices;
            this.totalCount = result.totalCount;
            this.groupByPipe.transform(result.customerInvoices, 'invoiceDate', '| date : MMMM yyyy, UTC, en-US').then(
                (result) => {
                    this.invoicesGroupedByMonth = result;
                    console.log(this.invoicesGroupedByMonth);
                    console.log(this.Object.keys(this.invoicesGroupedByMonth));
                }
            );
        });
    }

    getInvoiceStatusClass(status: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' | 'contrast' | undefined {
        switch(status) {
            case 'Betaald':
                return 'success';
            case 'Open':
                return 'info';
            case 'Te laat':
                return 'danger';
            default:
                return undefined;
        }
    }

    getInvoiceStatus(invoice: CustomerInvoice): 'Betaald' | 'Open' | 'Te laat' {
        return invoice.outstandingAmount === 0 ? 'Betaald' :
            invoice.invoiceDate <= new Date() ? 'Open' : 'Te laat';
    }

    showInvoiceDetail(invoice: CustomerInvoice) {
        this.invoiceDetailVisible[invoice.seqVerkoopkop] = !this.invoiceDetailVisible[invoice.seqVerkoopkop];
    }
}